module.exports = __webpack_public_path__ + "static/media/sandwich.b263d5f3.png";